function SorterDownArrow() {
  return (
    <svg
      width="9"
      height="20"
      viewBox="0 -2 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4686 0.938232H0.531521C0.293457 0.938232 0.160528 1.18959 0.307959 1.36119L4.2765 5.96295C4.39009 6.09467 4.60882 6.09467 4.72362 5.96295L8.69216 1.36119C8.83959 1.18959 8.70666 0.938232 8.4686 0.938232Z"
        fill="#959FAF"
      />
    </svg>
  );
}

export default SorterDownArrow;
